// extracted by mini-css-extract-plugin
export default {"slider":"Home_slider__Iy7Bn","popularDishes":"Home_popularDishes__YBhvf","little":"Home_little__FTXsS","big":"Home_big__3NTi0"};